import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ClientProfile } from "../../../interfaces/common";
import CustomButton from "../../../components/CustomButton";
import Checkbox from "../../../components/Checkbox";
import TextLink from "../../../components/TextLink";
import ChevronLeftIcon from "../../../components/Icons/ChevronLeftIcon";

interface Props {
  profile: ClientProfile;
  languages: Array<string>;
  save: (profile: ClientProfile) => void;
  goBack: () => void;
}

const StepThree: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const [languagesProfessional, setLanguagesProfessional] = useState<string[]>(
    props.profile.languagesProfessional
  );

  if (!props.languages) {
    return (
      <div>
        Fatal error - languages could not be loaded. Talk to support@zebrain.se
      </div>
    );
  }

  // Toggle function for professional languages
  const toggleProfessionalLanguage = (lang: string) => {
    setLanguagesProfessional((prev) =>
      prev.includes(lang) ? prev.filter((l) => l !== lang) : [...prev, lang]
    );
  };

  // Validation check
  const notValid = () => {
    // require at least one language in either native or professional
    return languagesProfessional.length === 0;
  };

  // Save changes
  const handleSave = () => {
    const newProfile: ClientProfile = {
      ...props.profile,
      languagesProfessional,
    };
    props.save(newProfile);
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <div className="z-heading2">{t("languages")}</div>
        <div className="text-gray-400">{t("select-coach-language")}</div>
      </div>

      {/* Professional languages */}
      <div className="max-w-sm space-y-2">
        <div className="flex flex-col gap-3 mt-2">
          {props.languages.map((option, index) => (
            <div key={"language_" + option}>
              <Checkbox
                id={option}
                checked={languagesProfessional.includes(option)}
                onChange={() => toggleProfessionalLanguage(option)}
                label={t("language_" + option)}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <CustomButton
          disabled={notValid()}
          className="mt-6"
          onClick={handleSave}
        >
          {t("next")}
        </CustomButton>

        {/* Back Link */}
        <TextLink
          color="white"
          onClick={props.goBack}
          leftIcon={<ChevronLeftIcon className="h-4 w-4 text-white!" aria-hidden="true" />}
          size="sm"
        >
          {t("back")}
        </TextLink>
      </div>
    </div>
  );
};

export default StepThree;
